/*
 * File: create-custom-prevent.ts
 * File Created: 2024-01-08 11:40:46
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-08 11:41:38
 * Modified By: Val Liu
 * -----
 */

export function createCustomPrevent() {
    const customEvent = {
        defaultPrevented: false,
        preventDefault: () => (customEvent.defaultPrevented = true),
    };
    return customEvent;
}
